<template>
  <div class="home texture-bg-css">
    <Carousels></Carousels>
    <Introduce></Introduce>
    <Cooperation></Cooperation>
    <News></News>
  </div>
</template>

<script>
import Carousels from '@/components/home/Carousels'
import Introduce from '@/components/home/Introduce'
import Cooperation from '@/components/home/Cooperation'
import News from '@/components/home/News'

export default {
  name: 'home',
  components: {
    Carousels,
    Introduce,
    Cooperation,
    News
  },
  mixins: [],
  data() {
    return {}
  },
  mounted: function() {},
  methods: {}
}
</script>
<style lang="scss"></style>
